import { FC, useState } from "react";
import { App } from "../../typings/App";
import {
  Box,
  Drawer as MaterialDrawer,
  List,
  useTheme,
} from "@mui/material";
import { AppItem } from "../AppItem";
import { useUIMode } from "../../wms/src/context/UIContext";

// Ancho del drawer cuando está colapsado (solo iconos)
const COLLAPSED_WIDTH = 72;

interface Props {
  isOpen: boolean;
  apps?: App[];
  onClose: () => void;
  onSelectName?: (name: string) => void;
}

export const Drawer: FC<Props> = ({ isOpen, apps, onClose, onSelectName }) => {
  const theme = useTheme();
  const { isMobile, isCollapsed } = useUIMode(); // Detectar si es mobile
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const drawerWidth = theme.drawer.width;
  // Ancho efectivo del papel: mini cuando está colapsado (solo desktop)
  const paperWidth = isCollapsed ? COLLAPSED_WIDTH : drawerWidth;

  const transition = theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: isOpen
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  });

  // Cálculo del ancho según el estado y dispositivo
  const drawerWidthValue = isMobile ? drawerWidth : isOpen ? paperWidth : 0;

  return (
    <MaterialDrawer      
      variant={isMobile ? "temporary" : "permanent"} // Variant temporary activa el cierre del menu al hacer clic fuera
      open={isOpen}
      onClose={onClose}
      sx={{
        width: isMobile ? 0 : drawerWidthValue,
        flexShrink: 0,
        transition,
        "& .MuiDrawer-paper": {
          width: paperWidth,
          boxSizing: "border-box",
          overflowX: "hidden",
          transition,
          // En desktop, si no está abierto, ocultamos el papel
          ...(!isOpen &&
            !isMobile && {
            width: 0,
          }),
        },
      }}
    >
      <Box sx={{ minHeight: 55 }} />
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        {apps &&
          apps.map((app) => (
            <AppItem
              key={app.name}
              app={app}
              onCloseDrawer={onClose}
              selectedItem={selectedItem}
              onSelectItem={setSelectedItem}
              onSelectName={onSelectName}
            />
          ))}
      </List>
    </MaterialDrawer>
  );
};
